<template>
  <div>
    <h2 class="text-center text-2xl font-bold mb-6">PLV</h2>
    <div class="my-10">
      <FormField id="kitNumber" v-model="kitNumber" label="Numéro de kit" />
      <FormField id="kitLink" v-model="kitLink" label="Lien du kit" />
    </div>
    <div class="flex justify-center">
      <GenericButton class="items-center" @click="updateContractDistribution">Mettre à jour</GenericButton>
    </div>
  </div>
</template>

<script>
import { FormField, GenericButton } from "@estaly/ui";
import { mapActions } from "vuex";
export default {
  components: {
    FormField,
    GenericButton,
  },
  props: ["contractDistribution"],
  emits: ["updated"],
  data() {
    return {
      kitNumber: this.contractDistribution.kitNumber || "",
      kitLink: this.contractDistribution.kitLink || "",
    };
  },
  methods: {
    ...mapActions("notifications", ["notify"]),
    ...mapActions("contractDistributions", ["update"]),

    async updateContractDistribution() {
      const response = await this.update({
        id: this.contractDistribution.id,
        data: {
          kitNumber: this.kitNumber,
          kitLink: this.kitLink,
        },
      });
      if (!response?.success) return;
      await this.notify({
        category: "simple",
        type: "success",
        title: "Mise à jour effectuée",
      });
      this.$emit("updated");
    },
  },
};
</script>
